import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const images = [
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/feb84a2a99fbcd7e8ff78c3e17f09320.jpeg",
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/d3137d59be0cffa96f7aa072f468a8a7.jpeg",
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/7bf14301ee7a6b604645c9ec2aebae83.jpeg",
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/2cd46f844316d9867f1ef19be25f2833.jpeg",
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/567ae914b096be40c10eb487428e7174.jpeg",
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/a2515f1fc094fd8ff5b758d413294b54.jpeg",
];

const photos = [
  { alt: "remplacement moteur Bubendorff volet roulant Strasbourg" },
  { alt: "technicien posant un moteur Bubendorff Bas-Rhin" },
  { alt: "moteur intégré Bubendorff déposé pour réparation Strasbourg" },
  { alt: "volet roulant Bubendorff avec batterie solaire remplacée" },
  { alt: "programmation télécommande Bubendorff après remplacement moteur" },
  { alt: "test fin de course volet Bubendorff réparé Strasbourg" },
];

export default function Galerie() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-8 text-center">
          Nos réalisations de remplacement de moteur Bubendorff
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {photos.map((photo, i) => (
            <div
              key={i}
              className="bg-brand-light border border-brand-border rounded-xl aspect-[4/3] overflow-hidden"
            >
              <ImagePlaceholder
                src={images[i]}
                alt={photo.alt}
                className="w-full h-full"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}